import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JohnDeereAuthService } from '../../services/john-deere-auth.service';
import { AuthService } from '../../../auth.service';

@Component({
  selector: 'app-jd-callback',
  standalone: false,
  templateUrl: './jd-callback.component.html',
  styleUrls: ['./jd-callback.component.css']
})
export class JdCallbackComponent implements OnInit {

  loading = true;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jdAuthService: JohnDeereAuthService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (!code || !state) {
      this.loading = false;
      this.error = 'Authorisation was cancelled or failed. Please try again.';
      return;
    }

    const pgUserId = this.authService.userSubject.value?.id?.toString();
    if (!pgUserId) {
      this.loading = false;
      this.error = 'User session not found. Please log in and try again.';
      return;
    }

    this.jdAuthService.submitCallback(code, state, pgUserId).subscribe({
      next: () => {
        this.router.navigate(['/john-deere/connected']);
      },
      error: () => {
        this.loading = false;
        this.error = 'Failed to complete the connection. Please try again.';
      }
    });
  }
}
